import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'

import store from './store'

import VueAxios from './plugins/axios'
import {func} from './plugins/func'
import Moment from 'vue-moment'
Vue.use(Moment);

import VueJsonToCsv from 'vue-json-to-csv'
Vue.use(VueJsonToCsv);

import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDqH0F1VXO8Qt0V_4BXeb_RqiO9cwWidQA', // ALL
    libraries: 'places',
  },

});

import Geocoder from "@pderas/vue2-geocoder";

Vue.use(Geocoder, {
  defaultCountryCode: 'DE', // e.g. 'CA'
  defaultLanguage:    'de', // e.g. 'en'
  defaultMode:        'address', // or 'lat-lng'
  googleMapsApiKey:   'AIzaSyDQfSidoCnLMO7sEv5pyP55wkBKDKK8_OU' // GEOCODING API
});


import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)


import {GmapCustomMarker} from 'vue2-gmap-custom-marker';
Vue.component('GmapCustomMarker', GmapCustomMarker);


// Using Cluster requires marker-clusterer-plus to be installed.
import GmapCluster from "gmap-vue/dist/components/cluster";

// Note: the name "cluster" below is the one to use in the template tags
Vue.component("cluster", GmapCluster);

Vue.prototype.$func = func

// Globale Variablen
// Vue.prototype.$api_endpoint = 'http://localhost/reifen/api.php'

/*
Vue.prototype.$header_title = 'Reifen Hüska'
Vue.prototype.$header_color = '#383083'
Vue.prototype.$header_logo = '@/assets/images/logo_hueska.png'

Vue.prototype.$api_endpoint = 'https://api.reifen-hueska.de/api/api.php'
Vue.prototype.$api_pdf_endpoint = 'https://api.reifen-hueska.de/create_pdf.php'
Vue.prototype.$api_upload = 'https://api.reifen-hueska.de/upload/'
Vue.prototype.$api_hostname = window.location.host
*/

// Vue.prototype.$api_endpoint = 'http://localhost/reifen/api.php'



/*
Vue.prototype.$header_title = 'Reifen Hüska'
Vue.prototype.$header_color = '#383083'
Vue.prototype.$header_logo = '@/assets/images/logo_hueska.png'

Vue.prototype.$api_endpoint = 'https://www.migro.net/reifen/api.php'
Vue.prototype.$api_pdf_endpoint = 'https://www.migro.net/reifen/create_pdf.php'
Vue.prototype.$api_upload = 'https://www.migro.net/reifen/upload/'
Vue.prototype.$api_hostname = window.location.host
*/


window.process = { env: { NODE_ENV: 'production' } };

Vue.prototype.$showKisMenu = true; 
Vue.prototype.$showCrmMenu = true; 

if (window.location.hostname.includes("reifen-hueska.de")){
  Vue.prototype.$header_title = 'Reifen Hüska'
  Vue.prototype.$header_color = '#383083'
  Vue.prototype.$header_logo = '@/assets/images/logo_hueska.png'

  Vue.prototype.$api_endpoint = 'https://api.reifen-hueska.de/api/api.php'
  Vue.prototype.$api_pdf_endpoint = 'https://api.reifen-hueska.de/create_pdf.php'
  Vue.prototype.$api_pdf_endpoint2 = 'https://api.reifen-hueska.de/_create_pdf.php'
  Vue.prototype.$api_upload = 'https://api.reifen-hueska.de/upload/'
  Vue.prototype.$api_hostname = window.location.host

   
  //Vue.prototype.$showCrmMenu = true;
  Vue.prototype.$hubspot_api_key = 'pat-eu1-78300e90-9c37-4a62-8c52-c30d78a2a0fd'
  Vue.prototype.$hubspot_companies_endpoint = 'https://www.migro.net/reifen/hubspot_companies.php'
  Vue.prototype.$hubspot_create_company_endpoint = 'https://www.migro.net/reifen/hubspot_create_company.php'
 




}else if (window.location.hostname.includes("reifen-muka.de")) {
  Vue.prototype.$header_title = 'Reifen Muka'
  Vue.prototype.$header_color = '#0826e3'
  Vue.prototype.$header_logo = '@/assets/images/logo_muka.png'

  Vue.prototype.$api_endpoint = 'https://www.reifen-muka.de/api/api.php'
  Vue.prototype.$api_pdf_endpoint = 'https://www.reifen-muka.de/api/create_pdf.php'
  Vue.prototype.$api_pdf_endpoint2 = 'https://www.reifen-muka.de/api/_create_pdf.php'
  Vue.prototype.$api_upload = 'https://www.reifen-muka.de/api/upload/'
  Vue.prototype.$api_hostname = window.location.host
  Vue.prototype.$showKisMenu = false;
  Vue.prototype.$showCrmMenu = true;

  

  Vue.prototype.$hubspot_api_key = 'pat-eu1-78300e90-9c37-4a62-8c52-c30d78a2a0fd'
  Vue.prototype.$hubspot_companies_endpoint = 'https://www.migro.net/reifen/hubspot_companies.php'
  Vue.prototype.$hubspot_create_company_endpoint = 'https://www.migro.net/reifen/hubspot_create_company.php'


}else if (window.location.hostname.includes("localhost")) {
  Vue.prototype.$header_title = 'Reifen Hüska - DEV'
  Vue.prototype.$header_color = '#383083'
  Vue.prototype.$header_logo = '@/assets/images/logo_hueska.png'


  Vue.prototype.$api_endpoint = 'https://api.reifen-hueska.de/api/api.php'
  Vue.prototype.$api_pdf_endpoint = 'https://api.reifen-hueska.de/create_pdf.php'
  Vue.prototype.$api_pdf_endpoint2 = 'https://api.reifen-hueska.de/_create_pdf.php'
  Vue.prototype.$api_upload = 'https://api.reifen-hueska.de/upload/'
  Vue.prototype.$api_hostname = window.location.host
  console.log(" setting for huska");
  //Vue.prototype.$showKisMenu = false; 

  Vue.prototype.$hubspot_api_key = 'pat-eu1-78300e90-9c37-4a62-8c52-c30d78a2a0fd'
  Vue.prototype.$hubspot_companies_endpoint = 'https://www.migro.net/reifen/hubspot_companies.php'
  Vue.prototype.$hubspot_create_company_endpoint = 'https://www.migro.net/reifen/hubspot_create_company.php'

}else if (window.location.hostname.includes("vercel")) {
  Vue.prototype.$header_title = 'Reifen Hüska - DEV'
  Vue.prototype.$header_color = '#383083'
  Vue.prototype.$header_logo = '@/assets/images/logo_hueska.png'


  Vue.prototype.$api_endpoint = 'https://api.reifen-hueska.de/api/api.php'
  Vue.prototype.$api_pdf_endpoint = 'https://api.reifen-hueska.de/create_pdf.php'
  Vue.prototype.$api_pdf_endpoint2 = 'https://api.reifen-hueska.de/_create_pdf.php'
  Vue.prototype.$api_upload = 'https://api.reifen-hueska.de/upload/'
  Vue.prototype.$api_hostname = window.location.host


  Vue.prototype.$hubspot_api_key = 'pat-eu1-78300e90-9c37-4a62-8c52-c30d78a2a0fd'
  Vue.prototype.$hubspot_companies_endpoint = 'https://www.migro.net/reifen/hubspot_companies.php'
  Vue.prototype.$hubspot_create_company_endpoint = 'https://www.migro.net/reifen/hubspot_create_company.php'

}


Vue.prototype.$password = "123qweasd"


// Axios
Vue.use(VueAxios);



Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
